import tinycolor from "tinycolor2";
import { COLOR, CSS_VARS } from "../styles";

const DARK_FOREGROUND_COLOR = COLOR.VY_BLACK;
const LIGHT_FOREGROUND_COLOR = COLOR.VY_WHITE; // TBD

const getForegroundColor = (backgroundColor) => {
  const color = `#${backgroundColor.replace('#', '')}`;
  return tinycolor.mostReadable(color, [DARK_FOREGROUND_COLOR, LIGHT_FOREGROUND_COLOR]).toHexString()
}

const lightenOrDarken = (color) => {
  return tinycolor(color).isLight()
    ? tinycolor(color).darken(2).toHexString()
    : tinycolor(color).lighten(14).toHexString();
}

/**
 * @returns CSSProperties | undefined
 */
export const getCustomPinColorStyles = () => {
  const params = new URLSearchParams(window.location.search);

  const storeColorParam = params.get('store_color_hex') ?? COLOR.VY_LILAC;
  const storeSelectedColorParam = params.get('store_selected_color_hex') ?? COLOR.VY_BLACK;
  const clusterColorParam = params.get('cluster_color_hex') ?? COLOR.WHITE;

  const storeColor = `#${storeColorParam.replace('#', '')}`;
  const storeSelectedColor = `#${storeSelectedColorParam.replace('#', '')}`;
  const clusterColor = `#${clusterColorParam.replace('#', '')}`;

  const clusterBackground = clusterColor;
  const storeBackground = storeColor;
  const storeSelectedBackground = storeSelectedColor;

  const clusterBorder = lightenOrDarken(clusterBackground);
  const storeBorder = lightenOrDarken(storeBackground);
  const storeSelectedBorder = lightenOrDarken(storeSelectedBackground);

  return {
    [CSS_VARS.PIN_STORE_BACKGROUND]: storeBackground,
    [CSS_VARS.PIN_STORE_FOREGROUND]: getForegroundColor(storeBackground),
    [CSS_VARS.PIN_STORE_BORDER]: storeBorder,

    [CSS_VARS.PIN_STORE_SELECTED_BACKGROUND]: storeSelectedBackground,
    [CSS_VARS.PIN_STORE_SELECTED_FOREGROUND]: getForegroundColor(storeSelectedBackground),
    [CSS_VARS.PIN_STORE_SELECTED_BORDER]: storeSelectedBorder,

    [CSS_VARS.PIN_CLUSTER_BACKGROUND]: clusterBackground,
    [CSS_VARS.PIN_CLUSTER_FOREGROUND]: getForegroundColor(clusterBackground),
    [CSS_VARS.PIN_CLUSTER_BORDER]: clusterBorder,
  }
};